import React from "react"

import { ChildSelector } from "../helpers/ChildSelector"

import * as threeColumnSectionStyles from "../styles/ThreeColumnSection.module.css"

export default function ThreeColumnSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `three-column-section-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const subTitle = ChildSelector.select(
    content,
    `three-column-lightbulb-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const textStack = content.childNodes
    .filter(node => node.classNames === "three-column-section-content")
    .map(t => t.text)

  const contentStack = ChildSelector.select(
    content,
    `three-column-section-content`,
    ChildSelector.SELECTOR_TYPE.ARRAY
  )

  const infoStack = ChildSelector.select(
    content,
    `three-column-information`,
    ChildSelector.SELECTOR_TYPE.ARRAY
  )

  const realisations = ChildSelector.select(
    content,
    `three-column-lightbulb-moment`,
    ChildSelector.SELECTOR_TYPE.NODE
  )

  return (
    <>
      <div
        className={`row ${threeColumnSectionStyles.externalWrapper} ${props.className}`}
      >
        <div
          className={`row ${threeColumnSectionStyles.wrapper} ${props.className}`}
        >
          <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-4 ${threeColumnSectionStyles.holder}`}>
            <h2 className={`${threeColumnSectionStyles.title}`}>{title}</h2>
          </div>
          <div className={`col-xs-12 col-sm-12 col-md-12  col-lg-4 ${threeColumnSectionStyles.holder}`}>
            {contentStack &&
              contentStack.map((c, idx) => (
                <p key={idx} className={`${threeColumnSectionStyles.content}`}>
                  {c.innerHTML}
                </p>
              ))}
          </div>
          {realisations && (
            <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-4 ${threeColumnSectionStyles.holder}`}>
              <h4 className={`${threeColumnSectionStyles.subTitle}`}>
                {subTitle}
              </h4>
              <ul className={`${threeColumnSectionStyles.content}`}>
                {realisations &&
                  realisations.childNodes &&
                  realisations.childNodes.length > 0 &&
                  realisations.childNodes.map((r, idx) => (
                    <li
                      key={idx}
                      className={`${threeColumnSectionStyles.contentItem}`}
                    >
                      {r.innerHTML}
                    </li>
                  ))}
              </ul>
            </div>
          )}
          {!realisations && (
            <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-4 ${threeColumnSectionStyles.holder}`}>
              {infoStack &&
                infoStack.map((c, idx) => (
                  <p
                    key={idx}
                    className={`${threeColumnSectionStyles.content}`}
                  >
                    {c.innerHTML}
                  </p>
                ))}
            </div>
          )}
        </div>
      </div>
    </>
  )
}
